import { render, staticRenderFns } from "./courseCatTree.vue?vue&type=template&id=245c580e&scoped=true&"
import script from "./courseCatTree.vue?vue&type=script&lang=js&"
export * from "./courseCatTree.vue?vue&type=script&lang=js&"
import style0 from "./courseCatTree.vue?vue&type=style&index=0&id=245c580e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c580e",
  null
  
)

export default component.exports